import { StyleSheet } from 'react-native';

export const Styles = StyleSheet.create({
  container: {
    borderRadius: 4,
    height: 40,
  },
  textInput: {
    fontSize: 16,
    alignSelf: 'stretch',
  },
});
